const namespaced = true

const state = {
  tribunals: [
    {
      id: 321414123,
      description: "TEst name goes here",
      reward: 150,
      amountType: "USD",
    },
    {
      id: 1234,
      description: "dasdsadae",
      reward: 100,
      amountType: "USD",
    }
  ],
  currentSort: 'name',
  currentSortDir: 'asc'
};

const getters = {
    tribunals: state => state.tribunals,
    currentSortDir: state => state.currentSortDir,
    currentSort: state => state.currentSort,
    sortedTribunals: state => {
      return state.tribunals
        .slice()
        .sort((a, b) => {
        let modifier = 1;
        if (state.currentSortDir === 'desc') modifier = -1;
        if (a[state.currentSort] < b[state.currentSort]) return -1 * modifier;
        if (a[state.currentSort] > b[state.currentSort]) return modifier;
        return 0;
      });
  }
};

const actions = {

};

const mutations = {
  changeCurrentSort(state, col) {
    state.currentSort = col;
  },
  changeSortDir(state, newValue) {
    state.currentSortDir = newValue;
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/tribunals/store.js